// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-size: 25px;
  margin-bottom: 5px;
  text-align: center;
}

.subHeading {
  text-align: center;
  color: #8a8a8a;
}

.shadow {
  width: 160px;
}

.fontweight600 {
  font-weight: 600;
}

.header2 .block-limiter {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}

.header2 .brandhotelselector {
  margin-top: 5px;
}

.bellContainer {
  position: relative;
  width: 50px;
}

.floatRight {
  float: right;
}

.marginBottom20 {
  margin-bottom: 20px;
}

.calender-selection {
  margin-top: 5px;
}

.calender-selection .control-select-men {
  display: inline-block;
  float: left;
}

.calender-selection .control-select-filter-men {
  display: inline-block;
  float: left;
}

.displayInline {
  display: inline !important;
}

.stdcontainer .block-limiter {
  padding: 0 10px 10px 10px;
}

.fullWidthSelect {
  width: 100% !important;
}

.shadow {
  width: 160px;
}

.noShadow {
  box-shadow: none;
}

.tagsContainer {
  float: left;
}

.iconsContainerStd {
  float: right;
}

.iconsContainerStd svg {
  height: 20px !important;
  width: 20px !important;
  margin-right: 10px;
}

.stdIconContainer {
  margin-top: 10px;
  width: 100%;
  display: inline-block;
}

.tagsContainer .tags-tag {
  background-color: #FFF;
  border: 1px solid #d1dbec;
}

.stdIconContainer svg {
  margin-right: 15px;
}

.tabContainer .tabContent {
  display: none;
}

.tabContainer .active {
  display: block;
}

.tabs {
  width: 100%;
}

.tabs .tabs-ul {
  list-style: none;
  padding-bottom: 12px;
  margin-bottom: 0px;
  display: inline-block;
  border-bottom: 1px solid #F1F1F1;
  overflow-x: auto;
  overflow-y: hidden;
  display: -webkit-box;
  display: -moz-box;
  white-space: nowrap;
}

.tabs .tabs-ul li {
  display: inline;
  margin-right: 10px;
  color: #919191;
  font-size: 18px;
  font-weight: 400;
  padding-bottom: 10px;
}

.tabs .tabs-ul li.activeTab {
  border-bottom: 3px solid #58c3bb;
  color: #000;
  font-weight: 600;
}

.subTabs {
  width: 100%;
  white-space: nowrap;
  overflow-x: auto;
}

.subTabs .subTabs-ul {
  list-style: none;
  padding-bottom: 20px;
  margin-bottom: 10px;
  display: inline-block;
  border-bottom: none;
  overflow-x: auto;
  overflow-y: hidden;
  display: -webkit-box;
  display: -moz-box;
  white-space: nowrap;
}

.subTabs .subTabs-ul li {
  display: inline;
  margin-right: 10px;
  color: #E1E1E1;
  font-size: 18px;
  font-weight: 400;
  padding-bottom: 10px;
  border-bottom: 1px solid #E1E1E1;
}

.subTabs .subTabs-ul li.activeSubTab {
  border-bottom: 2px solid #58c3bb;
  color: #58c3bb;
  font-weight: 600;
}

.subTabContainer {
  overflow-x: hidden;
  white-space: normal;
  min-height: 400px;
}

.subTabContainer .tabContent {
  display: none;
  padding: 10px;
}

.subTabContainer .active {
  display: block;
}

.tagsContainer .tags-tag {
  background-color: #fff;
  border: 1px solid #d1dbec;
  padding: 0px;
  font-size: 14px;
}

.bp3-menu-item .bp3-fill {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./styles.scss"],"names":[],"mappings":"AACA;EAAG,eAAA;EAAiB,kBAAA;EAAmB,kBAAA;AAGvC;;AAFA;EAAY,kBAAA;EAAoB,cAAA;AAOhC;;AANA;EAAQ,YAAA;AAUR;;AATA;EAAe,gBAAA;AAaf;;AAXA;EAAwB,iBAAA;EAAkB,kBAAA;EAAmB,mBAAA;AAiB7D;;AAhBA;EAA6B,eAAA;AAoB7B;;AAlBA;EAAe,kBAAA;EAAoB,WAAA;AAuBnC;;AAtBA;EAAY,YAAA;AA0BZ;;AAzBA;EAAgB,mBAAA;AA6BhB;;AA5BA;EAAoB,eAAA;AAgCpB;;AA9BA;EAAwC,qBAAA;EAAuB,WAAA;AAmC/D;;AAlCA;EAA+C,qBAAA;EAAuB,WAAA;AAuCtE;;AAtCA;EAAe,0BAAA;AA0Cf;;AAzCA;EAA6B,yBAAA;AA6C7B;;AA5CA;EAAiB,sBAAA;AAgDjB;;AA/CA;EAAQ,YAAA;AAmDR;;AAlDA;EAAU,gBAAA;AAsDV;;AArDA;EAAe,WAAA;AAyDf;;AAxDA;EAAmB,YAAA;AA4DnB;;AA3DA;EAAuB,uBAAA;EAAyB,sBAAA;EAAuB,kBAAA;AAiEvE;;AAhEA;EAAkB,gBAAA;EAAkB,WAAA;EAAY,qBAAA;AAsEhD;;AArEA;EAAyB,sBAAA;EAAwB,yBAAA;AA0EjD;;AAzEA;EAAuB,kBAAA;AA6EvB;;AA5EA;EAA0B,aAAA;AAgF1B;;AA/EA;EAAsB,cAAA;AAmFtB;;AAlFA;EAAM,WAAA;AAsFN;;AArFA;EAAe,gBAAA;EAAiB,oBAAA;EAAqB,kBAAA;EAAmB,qBAAA;EAAsB,gCAAA;EAAiC,gBAAA;EAAiB,kBAAA;EAAmB,oBAAA;EAAqB,iBAAA;EAAkB,mBAAA;AAkG1M;;AAjGA;EAAmB,eAAA;EAAiB,kBAAA;EAAoB,cAAA;EAAe,eAAA;EAAgB,gBAAA;EAAiB,oBAAA;AA0GxG;;AAzGA;EAA4B,gCAAA;EAAgC,WAAA;EAAa,gBAAA;AA+GzE;;AA7GA;EAAS,WAAA;EAAa,mBAAA;EAAoB,gBAAA;AAmH1C;;AAlHA;EAAqB,gBAAA;EAAiB,oBAAA;EAAqB,mBAAA;EAAoB,qBAAA;EAAsB,mBAAA;EAAoB,gBAAA;EAAiB,kBAAA;EAAmB,oBAAA;EAAqB,iBAAA;EAAkB,mBAAA;AA+HpM;;AA9HA;EAAyB,eAAA;EAAgB,kBAAA;EAAmB,cAAA;EAAe,eAAA;EAAgB,gBAAA;EAAiB,oBAAA;EAAqB,gCAAA;AAwIjI;;AAvIA;EAAqC,gCAAA;EAAgC,cAAA;EAAgB,gBAAA;AA6IrF;;AA5IA;EAAiB,kBAAA;EAAmB,mBAAA;EAAoB,iBAAA;AAkJxD;;AAjJA;EAA6B,aAAA;EAAc,aAAA;AAsJ3C;;AArJA;EAAyB,cAAA;AAyJzB;;AAxJA;EAA0B,sBAAA;EAAuB,yBAAA;EAA0B,YAAA;EAAa,eAAA;AA+JxF;;AA9JA;EACI,gBAAA;AAiKJ","sourcesContent":["h1 {\n  font-size: 25px;\n  margin-bottom: 5px;\n  text-align: center;\n}\n\n.subHeading {\n  text-align: center;\n  color: #8a8a8a;\n}\n\n.shadow {\n  width: 160px;\n}\n\n.fontweight600 {\n  font-weight: 600;\n}\n\n.header2 .block-limiter {\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n}\n\n.header2 .brandhotelselector {\n  margin-top: 5px;\n}\n\n.bellContainer {\n  position: relative;\n  width: 50px;\n}\n\n.floatRight {\n  float: right;\n}\n\n.marginBottom20 {\n  margin-bottom: 20px;\n}\n\n.calender-selection {\n  margin-top: 5px;\n}\n\n.calender-selection .control-select-men {\n  display: inline-block;\n  float: left;\n}\n\n.calender-selection .control-select-filter-men {\n  display: inline-block;\n  float: left;\n}\n\n.displayInline {\n  display: inline !important;\n}\n\n.stdcontainer .block-limiter {\n  padding: 0 10px 10px 10px;\n}\n\n.fullWidthSelect {\n  width: 100% !important;\n}\n\n.shadow {\n  width: 160px;\n}\n\n.noShadow {\n  box-shadow: none;\n}\n\n.tagsContainer {\n  float: left;\n}\n\n.iconsContainerStd {\n  float: right;\n}\n\n.iconsContainerStd svg {\n  height: 20px !important;\n  width: 20px !important;\n  margin-right: 10px;\n}\n\n.stdIconContainer {\n  margin-top: 10px;\n  width: 100%;\n  display: inline-block;\n}\n\n.tagsContainer .tags-tag {\n  background-color: #FFF;\n  border: 1px solid #d1dbec;\n}\n\n.stdIconContainer svg {\n  margin-right: 15px;\n}\n\n.tabContainer .tabContent {\n  display: none;\n}\n\n.tabContainer .active {\n  display: block;\n}\n\n.tabs {\n  width: 100%;\n}\n\n.tabs .tabs-ul {\n  list-style: none;\n  padding-bottom: 12px;\n  margin-bottom: 0px;\n  display: inline-block;\n  border-bottom: 1px solid #F1F1F1;\n  overflow-x: auto;\n  overflow-y: hidden;\n  display: -webkit-box;\n  display: -moz-box;\n  white-space: nowrap;\n}\n\n.tabs .tabs-ul li {\n  display: inline;\n  margin-right: 10px;\n  color: #919191;\n  font-size: 18px;\n  font-weight: 400;\n  padding-bottom: 10px;\n}\n\n.tabs .tabs-ul li.activeTab {\n  border-bottom: 3px solid #58c3bb;\n  color: #000;\n  font-weight: 600;\n}\n\n.subTabs {\n  width: 100%;\n  white-space: nowrap;\n  overflow-x: auto;\n}\n\n.subTabs .subTabs-ul {\n  list-style: none;\n  padding-bottom: 20px;\n  margin-bottom: 10px;\n  display: inline-block;\n  border-bottom: none;\n  overflow-x: auto;\n  overflow-y: hidden;\n  display: -webkit-box;\n  display: -moz-box;\n  white-space: nowrap;\n}\n\n.subTabs .subTabs-ul li {\n  display: inline;\n  margin-right: 10px;\n  color: #E1E1E1;\n  font-size: 18px;\n  font-weight: 400;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #E1E1E1;\n}\n\n.subTabs .subTabs-ul li.activeSubTab {\n  border-bottom: 2px solid #58c3bb;\n  color: #58c3bb;\n  font-weight: 600;\n}\n\n.subTabContainer {\n  overflow-x: hidden;\n  white-space: normal;\n  min-height: 400px;\n}\n\n.subTabContainer .tabContent {\n  display: none;\n  padding: 10px;\n}\n\n.subTabContainer .active {\n  display: block;\n}\n\n.tagsContainer .tags-tag {\n  background-color: #fff;\n  border: 1px solid #d1dbec;\n  padding: 0px;\n  font-size: 14px;\n}\n\n.bp3-menu-item .bp3-fill {\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
